<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Master Benefit Type</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Type</b>
      <br />
      <b-row class="mt-4">
        <b-col sm="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category"
            label-for="input-1"
          >
            <b-form-select
              v-model="category_id"
              name="category"
              v-validate="'required'"
              data-vv-as="Category"
              class="form-control"
            >
              <template v-slot:first>
                <option value disabled>-- Benefit Category --</option>
              </template>
              <option
                v-for="data in categories"
                :key="data.id"
                :value="data.id"
              >
                {{ data.display }}
              </option>
            </b-form-select>

            <p
              style="width: 100%; font-size: 80%;color: #dc3545;"
            >
              {{ veeErrors.first("category") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Type English"
            label-for="input-2"
          >
            <input
              id="input-2"
              placeholder="Type English"
              v-validate="'required'"
              v-model="display"
              data-vv-as="Type English"
              name="display"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-display-feedback">{{ veeErrors.first('display') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Type Bahasa"
            label-for="input-2"
          >
            <input
              id="input-2"
              placeholder="Type Bahasa"
              v-validate="'required'"
              v-model="display_id"
              data-vv-as="Type Bahasa"
              name="display_id"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-display_id-feedback">{{ veeErrors.first('display_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="mr-3"
            size="lg"
          >Create</b-button>
          <router-link :to="{name: 'BenefitType'}">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      display: "",
      display_id: "",
      category_id: "",
      categories: [],
    };
  },
  methods: {
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("display", this.display);
          formData.append("display_id", this.display_id);
          formData.append("category_id", this.category_id);
          this.$store
            .dispatch("BenefitTypeModule/postBenefitType", formData)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "BenefitType" });
              this.$swal({
                type: "success",
                title: "Your data has been saved",
                showConfirmButton: false,
                timer: 1500
              });
            })
            .catch(error => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500
              });
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    }
  },
  beforeMount() {
    this.$store
      .dispatch("BenefitCategoryModule/getBenefitCategories")
      .then((response) => {
        this.categories = response.data.data.categorys;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.categories = [];
      });
  },
};
</script>

<style>
</style>
